import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'csn-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignUpComponent {
  googleLoginUrl = environment.apiUrl + '/auth/google';
  passwordHidden = true;
  email: string = '';
  password: string = '';
  errorMessage: string | null = null;

  @ViewChild('emailInput') emailInputRef?: ElementRef<HTMLInputElement>;
  @ViewChild('passwordInput') passwordInputRef?: ElementRef<HTMLInputElement>;

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {
  }

  async signUpClicked() {
    // Password managers and browser autofill write directly to the DOM without
    // firing Angular's `input` event, leaving ngModel-bound properties empty.
    // Read nativeElement.value as fallback to capture whatever was filled.
    const email = this.email || this.emailInputRef?.nativeElement.value || '';
    const password = this.password || this.passwordInputRef?.nativeElement.value || '';

    this.errorMessage = null;
    try {
      await this.authService.basicSignup(email, password);
      this.authService.setAuthenticated();
      this.router.navigateByUrl('/courses');
    } catch (e: any) {
      this.errorMessage = e?.error?.details?.[0]?.message || e?.error?.error || e?.message || 'Sign-up failed. Please try again.';
      this.cdr.markForCheck();
    }
  }
}
